<template>
  <Available/>
  <Head/>
  <Sidebar/>
  <div class="open" id="main">
    <router-view :key='$route.params'></router-view>
    <Footer/>
  </div>
</template>
<script>
import {defineComponent} from 'vue';

import Availablefor from './landing_v2/components/ui/availablefor.vue'
export default defineComponent({
  name: 'App',
  components: {
    Available: Availablefor,
  },
  data() {
    return {}
  },

});
</script>

<style>
</style>